export enum DealStatuses {
  Lead = 0,
  New = 1,
  Submitted = 2,
  Approved = 3,
  Accepted = 4,
  WaitingToClose = 5,
  Funded = 6,
  Complete = 7,
  Parked = 8,
  Cancelled = 9,
  Declined = 10,
}

export enum NetworkTypes {
  Other = 0,
  DLC = 1,
  MCC = 2,
  MA = 3,
}

export enum PropertyOccupancyOptions {
  OwnerOccupied = 0,
  OwnerOccupiedAndRental = 1,
  Rental = 2,
  SecondHome = 3,
}

export enum CanadianProvinces {
  Alberta = 1,
  BritishColumbia = 2,
  Manitoba = 3,
  NewBrunswick = 4,
  Newfoundland = 5,
  NorthwestTerritories = 6,
  NovaScotia = 7,
  Nunavut = 8,
  Ontario = 9,
  PrinceEdwardIsland = 10,
  Quebec = 11,
  Saskatchewan = 12,
  Yukon = 13,
}

export enum ReferralTypes {
  Builder = 2,
  Realtor = 7,
  Client = 8,
  Other = 9,
  InsuranceAgent = 12,
  Solicitor = 13,
  FinancialPlanner = 14,
}

export enum ContactStatus {
  Contact = 1,
  Lead = 2,
}

export enum ContactSalutations {
  Mr = 1,
  Mrs = 2,
  Ms = 3,
  Dr = 4,
  Rev = 5,
  Miss = 6,
  Judge = 7,
}

export enum ContactSuffixTypes {
  Sr = 1,
  Jr = 2,
}

export enum ContactResidantTypes {
  CanadianCitizen = 10,
  LandedImmigrant = 22,
  WorkVisa = 30,
  Other = 99,
}

export enum ContactCorrespondenceLanguages {
  English = 1,
  French = 2,
}

export enum ContactRelationshipTypes {
  Spouse = 0,
  CommonLaw = 1,
  RelatedFamilyMember = 2,
  Other = 3,
  Parent = 4,
  Sibling = 5,
  Child = 6,
  Grandchild = 7,
  Grandparent = 8,
}

export enum BorrowerEmploymentEmployeeTypes {
  FullTime = 0,
  PartTime = 1,
  Seasonal = 2,
}

export enum BorrowerEmploymentIndustrySectors {
  Other = 0,
  Construction = 1,
  Government = 2,
  Health = 3,
  Education = 4,
  HighTech = 5,
  RetailSales = 6,
  LeisureOrEntertainment = 7,
  BankingOrFinance = 8,
  Transportation = 9,
  Services = 10,
  Manufacturing = 11,
  FarmingOrNaturalResources = 12,
  Varies = 13,
}

export enum IncomePeriods {
  Annual = 0,
  SemiAnnual = 1,
  Quarterly = 2,
  Monthly = 3,
  SemiMonthly = 4,
  BiWeekly = 5,
  Weekly = 6,
}

export enum EmployerReceivesBenefitsOptions {
  Default = 1,
  Yes = 2,
  No = 3,
  NoSelection = 4,
}

export enum LoanType {
  buy = 'Purchase',
  refinance = 'Refinance',
  renew = 'Switch / Transfer',
}

export enum BorrowerOtherIncomeTypes {
  InterestIncome = 4,
  ChildSupport = 5,
  Pension = 6,
  Alimony = 7,
  CanadianPensionPlan = 8,
  SurvivorBenefitPension = 9,
  Other = 10,
  OldAgeSecurity = 11,
  CanadaChildBenefit = 12,
}

export enum BorrowerPropertyFutureStatusTypes {
  Selling = 0,
  NotSelling = 1,
  Renting = 2,
}

export enum InsuranceReferralProviderOptions {
  None = 1,
  Insureline = 2,
  Opta = 3,
  SunLife = 4,
  Walnut = 5,
}

export enum PropertyFoundTypes {
  yes = 'Approval',
  no = 'Pre-Approval',
}

export enum HasLifeInsuranceOptions {
  Default = 1,
  Yes = 2,
  No = 3,
  NoSelection = 4,
}

export enum PreferredSocialMediaContact {
  None = 0 << 0,
  Facebook = 1 << 0, //1
  X = 1 << 1, //2
  Instagram = 1 << 2, //4
  LinkedIn = 1 << 3, //8
}
